import { Component, ViewChild } from '@angular/core';
import { MeetingsSidebarComponent } from './meetings-sidebar/meetings-sidebar.component';
import { MeetingsBoxComponent } from './meetings-box/meetings-box.component';

@Component({
  selector: 'app-meetings',
  imports: [
    MeetingsSidebarComponent,
    MeetingsBoxComponent
  ],
  templateUrl: './meetings.component.html',
  styleUrl: './meetings.component.scss',
  standalone: true
})
export class MeetingsComponent {
  @ViewChild(MeetingsBoxComponent) meetingsBoxchild!: MeetingsBoxComponent;
  
  async updateMeeting(meeting: any) {
    this.meetingsBoxchild.updateMeeting(meeting);
  }
}
